import { Button, Input } from "@heroui/react";
import { useState } from "react";
import { BigProfileCreation } from "@/api/businessProfiles";

interface BusinessProfileFormProps {
  defaults?: Partial<BigProfileCreation>;
  onSubmit: (data: Partial<BigProfileCreation>) => void;
}

export function BusinessProfileForm({
  defaults,
  onSubmit,
}: BusinessProfileFormProps) {
  const [formData, setFormData] = useState({
    business_display_name: defaults?.business_display_name || "",
    inn: defaults?.inn || "",
    ogrn: defaults?.ogrn || "",
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <div className="w-full">
      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <Input
          label="Название компании"
          placeholder="Введите название компании"
          value={formData.business_display_name}
          onChange={(e) =>
            setFormData((prev) => ({
              ...prev,
              business_display_name: e.target.value,
            }))
          }
          isRequired
          variant="bordered"
        />
        <Input
          label="ИНН"
          placeholder="Введите ИНН"
          value={formData.inn}
          onChange={(e) =>
            setFormData((prev) => ({ ...prev, inn: e.target.value }))
          }
          isRequired
          variant="bordered"
        />
        <Input
          label="ОГРН"
          placeholder="Введите ОГРН"
          value={formData.ogrn}
          onChange={(e) =>
            setFormData((prev) => ({ ...prev, ogrn: e.target.value }))
          }
          isRequired
          variant="bordered"
        />
        <div className="flex flex-row gap-2 justify-end">
          <Button
            type="submit"
            className="bg-elastic-500 hover:bg-elastic-600 text-black font-medium"
          >
            Далее
          </Button>
        </div>
      </form>
    </div>
  );
}
